export default "__VITE_ASSET__85d9834b__"